/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SamText } from './SamText'

export class StandardSubstance {
  constructor(json: JSON | any) {
    Object.assign(this as StandardSubstance, json)
  }

  code?: string
  type?: StandardSubstance.TypeEnum
  name?: SamText
  definition?: SamText
  url?: string
}
export namespace StandardSubstance {
  export type TypeEnum = 'CAS' | 'DM_D' | 'EDQM' | 'SNOMED_CT'
  export const TypeEnum = {
    CAS: 'CAS' as TypeEnum,
    DMD: 'DM_D' as TypeEnum,
    EDQM: 'EDQM' as TypeEnum,
    SNOMEDCT: 'SNOMED_CT' as TypeEnum,
  }
}
